import { FC, createContext, useContext, useState } from 'react';

import { useRequest } from '~hooks/index';
import { getAdmingBillingsList } from '~services/admin/billingList';
import { AdminBillingListBase } from '~services/admin/billingList/types';

import {
  DialogAssingBillingListContextValue,
  DialogAssingBillingListProps,
  DialogAssingBillingListPanelsId,
} from './types';
import { DEFAULT_BILLING_LIST_OPTION } from './utils';

const DialogAssingBillingListContext =
  createContext<DialogAssingBillingListContextValue>({
    activeTab: 'emptyState',
    setActiveTab: () => {},
    activeBillingLists: [],
    loadingActiveBillingLists: true,
    open: false,
    onClose: () => {},
    onConfirm: () => Promise.resolve(),
    loadinConfirm: false,
  });

export const useDialogAssingBillingListContext =
  (): DialogAssingBillingListContextValue =>
    useContext(DialogAssingBillingListContext);

const DialogAssingBillingListProvider: FC<DialogAssingBillingListProps> = ({
  children,
  ...restProps
}) => {
  const [activeTab, setActiveTab] =
    useState<DialogAssingBillingListPanelsId>('emptyState');

  const [activeBillingLists, setActiveBillingLists] = useState<
    AdminBillingListBase[]
  >([]);

  const [, loadingActiveBillingLists] = useRequest({
    request: getAdmingBillingsList,
    payload: null,
    withPostSuccess: (response) => {
      const currentBillingListsResponse = response.data
        ?.data as AdminBillingListBase[];

      const activesBillingList = currentBillingListsResponse.filter(
        (billingList) => billingList.enabled,
      );

      // if (activesBillingList.length > 0) {
      //   setActiveBillingLists(activesBillingList);
      //   setActiveTab('selection');
      // }

      setActiveBillingLists([
        DEFAULT_BILLING_LIST_OPTION,
        ...activesBillingList,
      ]);
      setActiveTab('selection');
    },
  });

  return (
    <DialogAssingBillingListContext.Provider
      value={{
        activeTab,
        setActiveTab,
        activeBillingLists,
        loadingActiveBillingLists,
        ...restProps,
      }}
    >
      {children}
    </DialogAssingBillingListContext.Provider>
  );
};

export default DialogAssingBillingListProvider;
